import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { bool, func, number } from 'prop-types';

const CustomQuantity = ({
  quantity,
  handleCustomQuantityUpdate,
  handleFocus,
  isFromSavedDrugs
}) => {
  const [inputQty, setInputQty] = useState('');
  const [isError, setIsError] = useState(false);
  const { t } = useTranslation();

  const handleSubmitClick = () => {
    if (
      inputQty === undefined ||
      _.isEmpty(inputQty) ||
      inputQty <= 0 ||
      inputQty.match(/^[-+]?[0-9]+\.[0-9]+$/)
    )
      setIsError(true);
    else handleCustomQuantityUpdate(inputQty);
  };

  const handleChange = e => {
    let value = e.target.value;
    if (value.length > 4) value = value.slice(0, 4);
    setInputQty(value);
    setIsError(value === 0);
  };

  const handleChangeMobile = e => {
    let value = e.target.value;
    if (value.length > 4) value = value.slice(0, 4);
    setInputQty(value);
    handleCustomQuantityUpdate(value);
    setIsError(value === 0);
  };

  const handleKeyPress = e => {
    const re = /[0-9A-F:]+/g;
    if (!re.test(e.key)) {
      e.preventDefault();
    }
  };

  useEffect(() => {
    if (quantity === 0) {
      setInputQty('');
    } else {
      setInputQty(quantity && quantity.toString());
    }
  }, [quantity]);

  return (
    <div className="customQuantitySection customQntyAda">
      {/*<div className="customQntyAda customQntyAdaHeader" id="custom-quantity">
        {' '}
        {t('Custom Quantity')}{' '}
      </div>*/}
      {/*{isError && (
        <span className="label-error">
          {t('Please enter a valid quantity.')}
        </span>
      )}*/}
      {!isFromSavedDrugs && (
        <div className="form-group desktop-only">
          <input
            className={`customQntyAda themeFocus ${isError && 'errorInput'}`}
            tabIndex="0"
            value={inputQty}
            onChange={e => handleChange(e)}
            type="number"
            onKeyDown={e => {
              if (e.key === 'Enter') handleSubmitClick();
              else handleKeyPress(e);
            }}
            onPaste={e => {
              e.preventDefault();
              return false;
            }}
            onFocus={() => handleFocus()}
            aria-labelledby="custom-quantity"
            aria-required="true"
            inputMode="numeric"
          />
          <button
            tabIndex="0"
            type="submit"
            className="doneButton"
            onClick={() => handleSubmitClick()}
            onKeyDown={e => {
              if (e.key === 'Enter') {
                e.preventDefault();
                handleSubmitClick();
              }
            }}
            disabled={!(inputQty > 0)}
          >
            <img
              src="/content/images/prescriptions/doneArrow.svg"
              width="24"
              height="24"
            />
          </button>
        </div>
      )}
      <div className={`form-group ${!isFromSavedDrugs && 'mobile-only'}`}>
        <input
          value={inputQty}
          type="number"
          onChange={e => handleChangeMobile(e)}
          onFocus={() => handleFocus()}
          onKeyDown={e => handleKeyPress(e)}
          className="dialogComponent mobileDialog themeFocus customQtyfocus"
          inputMode="numeric"
          onPaste={e => {
            e.preventDefault();
            return false;
          }}
          placeholder={t('Custom-label')}
        />
      </div>
    </div>
  );
};

CustomQuantity.propTypes = {
  handleFocus: func,
  handleCustomQuantityUpdate: func,
  quantity: number,
  isFromSavedDrugs: bool
};

CustomQuantity.defaultProps = {
  handleFocus: () => {},
  handleCustomQuantityUpdate: () => {},
  quantity: 0,
  isFromSavedDrugs: false
};

export default CustomQuantity;
